<template>
  <div class="home-page">
    <div class="bg"></div>
    <div class="content">
      <div class="core">
        <div class="btn">
          <img src="./../../assets/home/microscopeTrue.png" alt />
          显微镜操作判读考核
        </div>
        <div class="text">
          本环节中您将模拟显微镜操作判读过程:请按照提示完成显微镜调试，之后您将随机获得两张玻片，并分别进行判读。每人只有<span>1</span>次考试机会，总分
          <span>100</span>分，作答时间 <span>20</span>分钟。
        </div>
        <div class="text">显微镜操作判读考核的答案即时查看。欢迎大家通过爱波克杯皮肤病大赛小程序进入本页面查看答案。
        </div>
        <div @click="visibles = true" class="partake">参与考试</div>
      </div>
      <div @click="handleGoMicroscopeGrade" class="rule">评分规则</div>
    </div>
    <div class="page-microModal" v-show="visibles">
      <div class="content">
        <div class="text">
          <p>考核限时20分钟,</p>
          <p>请在规定时间内完成题目。</p>
        </div>
        <div class="footer">
          <button @click="handleGoMicroscopeStart">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getSlidePaper } from "@/api/system/exam";
export default {
  name: "Home2026",
  data() {
    return {
      visibles: false,
      slideData: null,
      modelTimes: 10,
      isLoading: false,
    };
  },
  created() {
    // this.init()
  },
  methods: {
    // vuex存放数据
    ...mapMutations("microscope", ["handleMicroscope"]),
    ...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
    // 去开始
    handleGoMicroscopeStart() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      getSlidePaper().then((response) => {
        this.handleMicroscope({
          key: "slidePaper",
          value: response.data.data,
        });
        this.visibles = false;
        this.isLoading = false;
        this.handleMicroscope({ key: "microscopeModleTime", value: true });
        this.$router.replace("/microscope/start");
      });
    },

    // 去规则
    handleGoMicroscopeGrade() {
      this.$router.push("/microscope/grade");
    },
  },
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  .page-microModal {
    width: 100%;
    min-height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(#fff, 0.8);
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    z-index: 1;
    .content {
      width: 100%;
      height: 642px;
      z-index: 999;
      box-sizing: border-box;
      background: #ffffff;
      background: rgba(255, 255, 255, 0.9);
      border: 2px solid #ffffff;
      border-radius: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 90px;
      padding-bottom: 77px;
    }
    .title {
      font-size: 65px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #ab3b91;
    }
    .text {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      line-height: 60px;
      text-align: center;
    }
    .footer {
      margin-top: 110px;
      button {
        width: 262px;
        height: 79px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
        border: 1px solid #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        text-align: center;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 60px;
        letter-spacing: 2px;
        border-radius: 40px;
      }
      button:nth-child(2) {
        margin-left: 42px;
      }
    }
  }
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    height: 1224px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 1px;
    .core {
      width: 496px;
      margin: 48px 78px;
      // height: 856px;
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
      border-radius: 60px;
      padding-bottom: 50px;
      .btn {
        width: 100%;
        height: 100px;
        border-radius: 50px;
        margin: 0 auto;
        font-size: 36px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        line-height: 101px;
        text-align: center;
        border: 1px solid #ffffff;
        background: #e5e5e5;
        color: #333333;
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        img {
          display: inline;
          width: 47px;
          vertical-align: middle;
        }
      }
      .text {
        margin-top: 80px;
        padding: 0 30px;
        font-size: 25px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #4c4c4c;
        line-height: 50px;
        span {
          color: #ab3b91;
        }
      }
      .partake {
        width: 339px;
        height: 69px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
        border: 1px solid #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        border-radius: 34px;
        margin: 0 auto;
        text-align: center;
        line-height: 69px;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        margin-top: 50px;
      }
    }
    .rule {
      width: 496px;
      margin: 0 auto;
      height: 66px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      opacity: 0.85;
      border-radius: 33px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 48px;
      text-align: center;
      line-height: 66px;
    }
  }
}
</style>
